<template>
    <div class="card" @click="handleRouterSkip" :class="{'mar_r_0':(index+1)%2==0}">
        <img :src="item.Cover" alt="">
        <p>{{item.Title}}</p>
        <p>{{item.Summary}}</p>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => { return {} }
        },
        index: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {}
    },
    created() {
    },
    methods: {
        handleRouterSkip() {
            this.$router.push({ name: 'Details', query: { id: this.item.NewsID } })
        },
    }
}
</script>

<style lang="less" scoped>
.mar_r_0 {
    margin-right: 0px !important;
}
.card {
    width: 161px;
    height: 183px;
    background-color: #fff;
    margin-right: 13px;
    margin-bottom: 12px;
    & img {
        width: 100%;
        height: 105px;
        display: block;
    }
    & >p:nth-child(2) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        line-height: 18px;
        padding: 0 8px;
        margin:8px 0;
    }
    & >p:nth-child(3) {
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        padding: 0 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}
</style>